import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const infos = [
  { label: 'Nom de l\'entreprise', value: 'KRUTAK' },
  { label: 'Dirigeante', value: 'Maria Ruta Krutak' },
  { label: 'Statut juridique', value: 'Entrepreneur individuel' },
  { label: 'SIRET', value: '999 389 893 00010' },
  { label: 'Code APE / NAF', value: '70.22Z – Conseil pour les affaires et autres conseils de gestion' },
  { label: 'Adresse', value: '23 Rue Nationale, 59800 Lille, France' },
  { label: 'Téléphone', value: '+33 6 39 93 63 29', link: 'tel:+33639936329' },
  { label: 'Email', value: 'mariakrutak02@inbox.eu', link: 'mailto:mariakrutak02@inbox.eu' },
];

export default function InformationsEntreprisePage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      <section className="pt-36 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-4 block">
            Transparence
          </span>
          <h1 className="text-4xl font-bold text-navy-800">
            Informations entreprise
          </h1>
          <p className="text-gray-500 text-lg mt-4 leading-relaxed">
            Toutes les informations légales et de contact relatives à KRUTAK.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="bg-gray-50 rounded-2xl border border-gray-100 overflow-hidden">
            {infos.map((info, i) => (
              <div
                key={i}
                className={`flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-8 px-8 py-5 ${i !== infos.length - 1 ? 'border-b border-gray-100' : ''}`}
              >
                <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 sm:w-48 shrink-0">
                  {info.label}
                </span>
                {info.link ? (
                  <a
                    href={info.link}
                    className="text-navy-800 font-medium text-[15px] hover:text-navy-600 transition-colors duration-200 cursor-pointer"
                  >
                    {info.value}
                  </a>
                ) : (
                  <span className="text-navy-800 font-medium text-[15px]">{info.value}</span>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 bg-navy-800 rounded-2xl p-10">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-xl shrink-0">
                <i className="ri-map-pin-2-line text-white text-2xl" />
              </div>
              <div>
                <h2 className="text-white font-bold text-xl mb-2">Localisation</h2>
                <p className="text-gray-300 text-[15px] leading-relaxed">
                  KRUTAK est basé au cœur de Lille, au 23 Rue Nationale, 59800 Lille.
                  Interventions possibles à Lille, dans les Hauts-de-France et à distance sur toute la France.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 rounded-2xl overflow-hidden border border-gray-100 h-72">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2530.6871938247447!2d3.0621559!3d50.6311747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c2d5a6df4b8b85%3A0x7b0a9c5e0c7b2d1a!2s23%20Rue%20Nationale%2C%2059800%20Lille%2C%20France!5e0!3m2!1sfr!2sfr!4v1699000000000!5m2!1sfr!2sfr"
              width="100%"
              height="288"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation KRUTAK – 23 Rue Nationale Lille"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
